module.exports = __webpack_public_path__ + "img/right-more-6.00565461.png";